import { styled } from 'styled-components';
import { token } from '@bynder/design-system';

export const Track = styled.div<{ $visible: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    z-index: 1010;
    overflow: hidden;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    transition: opacity 300ms ease;
    pointer-events: none;
`;

export const Fill = styled.div<{ $progress: number }>`
    height: 100%;
    width: ${({ $progress }) => $progress}%;
    background-color: ${token.brandPrimary500};
    border-radius: 0 2px 2px 0;
    transition: width 400ms ease;
`;
